import { render } from "./FavouritesList.vue?vue&type=template&id=28909b32"
import script from "./FavouritesList.vue?vue&type=script&lang=js"
export * from "./FavouritesList.vue?vue&type=script&lang=js"

import "./FavouritesList.vue?vue&type=style&index=0&id=28909b32&lang=css"
script.render = render

export default script